import { emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { currentUserStore } from '../../../../CurrentUserStore';
import { findLinkBy } from '../../../../Links';
import { useQueryWithDecoder } from '../../../../UseQueryWithDecoder';
import CardTitle from '../../Shared/CardTitle';
import Content from './Content';
import { keyMetricsResourceDecoder } from './Decoder';
import KeyMetricsSkeleton from './KeyMetricsSkeleton';

function KeyMetrics() {
  const { data, isLoading, error } = useQueryWithDecoder(
    'key-metrics',
    currentUserStore.links,
    keyMetricsResourceDecoder,
  );

  if (isLoading) {
    return <KeyMetricsSkeleton />;
  }

  if (error || !data) {
    console.error('Failed to load key metrics:', error);
    return emptyFragment();
  }

  const { payload } = data;
  return (
    <>
      <CardTitle title="Overall Engagement" />
      <div className="w-full flex flex-wrap justify-between gap-2">
        <Content keyMetrics={payload} title="Active Participants" rangeText="In the last 30 days" />
        {findLinkBy({ rel: 'product-licenses-lima' }, currentUserStore.links)
          .map(() => (
            <Content
              keyMetrics={payload}
              title="Activated Licenses"
              rangeText="In the current license term"
            />
          ))
          .getOrElse(emptyFragment)}
        <Content
          keyMetrics={payload}
          title="Programs In Use"
          rangeText="In published collections"
        />
      </div>
    </>
  );
}

export default observer(KeyMetrics);
